import { gql } from '@apollo/client';
import { useApolloClient, useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

const alterBookingStateMutation = gql`
    mutation alterBookingState($id: Int!, $fields: BookingStateInput!) {
        alterBookingState(id: $id, fields: $fields) {
            reference
        }
    }
`;

const useUpdateBookingField = <T>({
    id,
    field,
    initialValue,
    defaultValue,
    isNumeric,
}: {
    id: string | number;
    field: string;
    initialValue: T;
    defaultValue: T;
    isNumeric?: boolean;
}) => {
    const client = useApolloClient();
    const [currentValue, setCurrentValue] = useState<T>(
        initialValue || defaultValue
    );
    const [alterBookingState] = useMutation(alterBookingStateMutation);

    const update = useCallback(() => {
        alterBookingState({
            variables: {
                id,
                fields: {
                    [field]: isNumeric ? +currentValue : currentValue,
                },
            },
        })
            .then(async () => {
                await client.clearStore();
                await client.refetchObservableQueries();
            })
            .catch(error => {
                throw error;
            });
    }, [currentValue, id, client, alterBookingState, field, isNumeric]);

    return {
        currentValue,
        setValue: setCurrentValue,
        update,
    };
};

export default useUpdateBookingField;
